const Auth = () => import('@/views/Auth');
const Geolocation = () => import('@/views/Geolocation');
const Sms = () => import('@/views/Sms');
const ClientConfirmation = () => import('@/views/ClientConfirmation');
const ContactUs = () => import('@/views/ContactUs');
const PasswordReset = () => import('@/views/PasswordReset');
const Assistance = () => import('@/views/Assistance');
const ListCicloUrbano = () => import('@/components/lodgings/ListCicloUrbano');
const ListAgroServices = () => import('@/components/lodgings/ListAgroServices');
const ListUrbanPlagas = () => import('@/components/lodgings/ListUrbanPlagas');
const ListBiotecPlagas = () => import('@/components/lodgings/ListBiotecPlagas');
const ListLusazu = () => import('@/components/lodgings/ListLusazu');
const ListRoedores = () => import('@/components/lodgings/ListRoedores');
const ListCicloUrbanoPiscinas = () => import('@/components/lodgings/ListCicloUrbanoPiscinas');
const FormLusazu = () => import('@/views/childrens/guest/FormLusazu');
const FormRoedores = () => import('@/views/childrens/guest/FormRoedores');

export default [
	{
		path: '/passwordReset',
		name: 'passwordReset',
		component: PasswordReset,
		meta: { title: 'Recuperar contraseña', layout: 'simple' },
	},
	{
		path: '/contact-us',
		name: 'contact',
		component: ContactUs,
		meta: { title: 'Contacto', layout: 'simple' },
	},
	{
		path:
			'/geolocation/person/:id/token/:token/lodging/:lodging/notification/:idNotification/handler/:handler',
		name: 'geolocation',
		component: Geolocation,
		meta: { title: 'Confirmar geolocalización', layout: 'simple' },
	},
	{
		path: '/sms/person/:id/token/:token/lodging/:lodging/notification/:idNotification',
		name: 'confirm-sms',
		component: Sms,
		meta: { title: 'Confirmar Actividad', layout: 'simple' },
	},
	{
		path: '/client-confirmation/:idLodging',
		name: 'client-confirmation',
		component: ClientConfirmation,
		meta: { title: 'Confirmar Actividad', layout: 'simple' },
	},
	{
		path: '/assistance',
		name: 'assistance-guest',
		component: Assistance,
		meta: { title: 'Asistencia', layout: 'simple' },
	},
	{
		path: '/auth',
		name: 'auth',
		component: Auth,
		meta: { title: 'Autenticación', layout: 'simple' },
	},
	{
		path: '/ciclo-urbano/:idLodging/work-order/:index/',
		name: 'list-ciclo-urbano',
		component: ListCicloUrbano,
		meta: { title: 'Ciclo urbano', layout: 'simple' },
	},
	{
		path: '/agro-services/:idLodging/work-order/:index/',
		name: 'list-agro-service',
		component: ListAgroServices,
		meta: { title: 'Agroservices', layout: 'simple' },
	},
	{
		path: '/urban-plagas/:idLodging/work-order/:index/',
		name: 'list-urban-plagas',
		component: ListUrbanPlagas,
		meta: { title: 'Urban Plagas', layout: 'simple' },
	},
	{
		path: '/ciclo-urbano-piscinas/:idLodging/work-order/:index/',
		name: 'list-ciclo-urbano-piscinas',
		component: ListCicloUrbanoPiscinas,
		meta: { title: 'Ciclo urbano piscinas', layout: 'simple' },
	},
	{
		path: '/biotec-plagas/:idLodging/work-order/:index/',
		name: 'list-biotec-plagas',
		component: ListBiotecPlagas,
		meta: { title: 'Biotec plagas', layout: 'simple' },
	},
	{
		path: '/biotec-plagas-certificate/:idLodging/work-order/:index/',
		name: 'list-biotec-plagas-certificate',
		component: ListBiotecPlagas,
		meta: { title: 'Biotec certificado', layout: 'simple' },
	},
	// list
	{
		path: '/lusazu/:idLodging/work-order/:index/',
		name: 'list-lusazu',
		component: ListLusazu,
		meta: { title: 'Plagas', layout: 'simple' },
	},
	{
		path: '/roedores/:idLodging/work-order/:index/',
		name: 'list-roedores',
		component: ListRoedores,
		meta: { title: 'Roedores', layout: 'simple' },
	},
	// form OT edit
	{
		path: '/nueva-orden-de-trabajo/lusazu/:idLodging/:index/',
		name: 'edit-form-lusazu',
		component: FormLusazu,
		meta: { title: 'Plagas', layout: 'simple' },
	},
	{
		path: '/nueva-orden-de-trabajo/pre-roedores/:idLodging/:index/',
		name: 'edit-form-roedores',
		component: FormRoedores,
		meta: { title: 'Pre-roedores', layout: 'simple' },
	},
	// list certificado
	{
		path: '/lusazu-certificate/:idLodging/work-order/:index/',
		name: 'list-lusazu-certificate',
		component: ListLusazu,
		meta: { title: 'Plagas', layout: 'simple' },
	},
	{
		path: '/roedores-certificate/:idLodging/work-order/:index/',
		name: 'list-roedores-certificate',
		component: ListRoedores,
		meta: { title: 'Roedores', layout: 'simple' },
	},
	// form ot routes
	{
		path: '/nueva-orden-de-trabajo/lusazu/',
		name: 'form-lusazu',
		component: FormLusazu,
		meta: { title: 'Nueva orden de trabajo', layout: 'simple' },
	},
	{
		path: '/nueva-orden-de-trabajo/roedores/',
		name: 'form-roedores-mobile',
		component: FormRoedores,
		meta: { title: 'Nueva orden de trabajo', layout: 'simple' },
	},
];
